import React from "react";
import ReactDOM from "react-dom";
import SpecialPackageSection from "../components/SpecialPackageSection";
import { initializeI18n } from '../localization/i18n';

// Expose render function globally
window.renderSpecialPackageSection = (elementId, props) => {
  const element = document.getElementById(elementId);
  if (element) {

    initializeI18n()
      .then((i18nInstance) => {
        ReactDOM.render(<SpecialPackageSection props={props} />, element);
      })
      .catch(error => {
        //console.error("Failed to initialize i18n before rendering SpecialPackageSection:", error);
      });

  } else {
    //console.error(`Element with ID ${elementId} not found.`);
  }
};
